import * as T from 'prop-types';
import Lottie from 'react-lottie-player';

const AnimatedImage = ({ ariaLabel, loop, play, role, src, style, title }) => (
  <Lottie
    play={play}
    loop={loop}
    aria-label={ariaLabel}
    role={role}
    style={style}
    title={title}
    animationData={src}
  />
);

AnimatedImage.propTypes = {
  /**
   * What is the animation's JSON content?
   */
  src: T.shape({}).isRequired,
  /**
   * Does the animation start automatically?
   * @default true
   */
  play: T.bool,
  /**
   * Does this animation repeat?
   * @default false
   */
  loop: T.oneOfType([T.number, T.bool]),
  /**
   * What is the animation style?
   * @default {}
   */
  style: T.shape({}),
  /**
   * What is the animation role?
   * @default 'presentation'
   */
  role: T.string,
  /**
   * What is the animation ariaLabel?
   * @default 'animation'
   */
  ariaLabel: T.string,
  /**
   * What is the animation title?
   */
  title: T.string,
};

AnimatedImage.defaultProps = {
  play: true,
  loop: false,
  style: {},
  role: 'presentation',
  ariaLabel: 'animation',
  title: null,
};

export default AnimatedImage;
